import { Directive, Input } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * used internally by the table component to render custom angular components as header content
 */
/**
 * @deprecated use v3 version of this component instead
 */
export class HeaderRendererV2Directive {
  vcRef;
  geauiHeaderRendererComponent;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  geauiRendererConfig;
  geauiTableId;
  geauiDisplayName;
  constructor(vcRef) {
    this.vcRef = vcRef;
  }
  ngOnInit() {
    this.createComponent();
  }
  createComponent() {
    const componentRef = this.vcRef.createComponent(this.geauiHeaderRendererComponent);
    if (componentRef?.instance) {
      // The config is of type any to make is flexible for any type of component
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      componentRef.instance.config = this.geauiRendererConfig;
      componentRef.instance.tableId = this.geauiTableId;
      componentRef.instance.displayName = this.geauiDisplayName;
    }
    return componentRef;
  }
  static ɵfac = function HeaderRendererV2Directive_Factory(t) {
    return new (t || HeaderRendererV2Directive)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderRendererV2Directive,
    selectors: [["", "geauiHeaderRendererComponent", ""]],
    inputs: {
      geauiHeaderRendererComponent: "geauiHeaderRendererComponent",
      geauiRendererConfig: "geauiRendererConfig",
      geauiTableId: "geauiTableId",
      geauiDisplayName: "geauiDisplayName"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderRendererV2Directive, [{
    type: Directive,
    args: [{
      selector: '[geauiHeaderRendererComponent]'
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }], {
    geauiHeaderRendererComponent: [{
      type: Input
    }],
    geauiRendererConfig: [{
      type: Input
    }],
    geauiTableId: [{
      type: Input
    }],
    geauiDisplayName: [{
      type: Input
    }]
  });
})();
